var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 112,
    viewBox: "0 0 142 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.2 40H36.8C34.149 40 32 42.149 32 44.8V91.2C32 93.851 34.149 96 36.8 96H123.2C125.851 96 128 93.851 128 91.2V44.8C128 42.149 125.851 40 123.2 40Z",
    stroke: "#364A43",
    strokeWidth: 0.979362
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M128 40H32V56H128V40Z",
    fill: "#364A43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4 68H45.6C44.7163 68 44 68.7163 44 69.6V71.2C44 72.0837 44.7163 72.8 45.6 72.8H74.4C75.2837 72.8 76 72.0837 76 71.2V69.6C76 68.7163 75.2837 68 74.4 68Z",
    stroke: "#364A43",
    strokeWidth: 0.979362
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4 80H45.6C44.7163 80 44 80.7163 44 81.6V83.2C44 84.0837 44.7163 84.8 45.6 84.8H90.4C91.2837 84.8 92 84.0837 92 83.2V81.6C92 80.7163 91.2837 80 90.4 80Z",
    stroke: "#364A43",
    strokeWidth: 0.979362
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112 86.4038C116.418 86.4038 120 82.8221 120 78.4038C120 73.9855 116.418 70.4038 112 70.4038C107.582 70.4038 104 73.9855 104 78.4038C104 82.8221 107.582 86.4038 112 86.4038Z",
    stroke: "#364A43",
    strokeWidth: 0.979362
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.d19bf7621428dd518280fc6af28a0089.svg";
export { ForwardRef as ReactComponent };